import { createAction, props } from '@ngrx/store'
import { UserState, UserPermissionsObject } from '../reducers/user.reducer'

export const authenticate = createAction('[User] Authenticate')
export const authenticateSuccess = createAction(
  '[User] Authenticate Success',
  props<{ user: UserState; permissions: UserPermissionsObject }>(),
)
export const authenticateFailure = createAction('[User] Authenticate Failure', props<{ error: any }>())

export const login = createAction('[User] Login', props<{ email: string; password: string; remember_me: boolean }>())
export const loginSuccess = createAction('[User] Login Success')
export const loginFailure = createAction('[User] Login Failure', props<{ error: any }>())

export const logout = createAction('[User] Logout')
export const logoutSuccess = createAction('[User] Logout Success')
export const logoutFailure = createAction('[User] Logout Failure', props<{ error: any }>())

export const updateAvatar = createAction('[User] Update Avatar', props<{ url: string }>())
export const updateAvatarFailure = createAction('[User] Update Avatar Failure', props<{ error: any }>())

export const changeAvatar = createAction('[User] Change Avatar', props<{ file: File }>())
export const changeAvatarSuccess = createAction('[User] Change Avatar Success', props<{ url: string }>())
export const changeAvatarFailure = createAction('[User] Change Avatar Failure', props<{ error: any }>())
